import { Button as MUIButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import Theme from 'App.theme';

const Button = withStyles({
  root: {
    backgroundColor: Theme.colours.primary,
    borderRadius: '0.5rem',
    height: '48px',
    color: 'white',
    fontSize: '1rem',
    boxShadow: '2px 2px 5px 0px ' + Theme.greys.GREY0,
    fontFamily: Theme.font,
    '&:hover': {
      boxShadow: '2px 2px 5px 0px ' + Theme.greys.GREY1,
      backgroundColor: Theme.colours.primaryDark,
    },
  },
  disabled: {
    backgroundColor: Theme.greys.GREY0,
  },
})(MUIButton);

export default Button;
